import React, { useRef, useEffect } from 'react';

type ContentEditableProps = {
  html: string;
  onChange: (html: string) => void;
  className?: string;
  placeholder?: string;
};

const ContentEditable = ({
  html,
  onChange,
  className,
  placeholder
}: ContentEditableProps) => {
  const contentEditableRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentEditableRef.current && contentEditableRef.current.innerHTML !== html) {
      contentEditableRef.current.innerHTML = html;
    }
  }, [html]);

  return (
    <div
      ref={contentEditableRef}
      className={className}
      contentEditable
      suppressContentEditableWarning
      onInput={(e) => onChange((e.target as HTMLDivElement).innerHTML)}
      data-placeholder={placeholder}
    />
  );
};

export default ContentEditable;
